import type { Schema } from '@wix/editor-elements-corvid-utils';

const linkDataTypes = [
  'DocumentLink',
  'EmailLink',
  'ExternalLink',
  'PageLink',
  'DynamicPageLink',
  'TpaPageLink',
  'PhoneLink',
  'WhatsAppLink',
  'AddressLink',
  'LoginToWixLink',
  'AnchorLink',
] as const;

const linkDataTarget = ['_self', '_blank'] as const;

export const linkMetaDataSchema: Schema = {
  type: ['object', 'nil'],
  additionalProperties: false,
  properties: {
    type: {
      type: ['string'],
      enum: [...linkDataTypes],
    },
    target: {
      type: ['string'],
      enum: [...linkDataTarget],
    },
    rel: { type: ['string'] },
    linkPopupId: { type: ['string'] },
    anchorDataId: { type: ['string'] },
    anchorCompId: { type: ['string'] },
    docInfo: {
      type: ['object'],
      additionalProperties: false,
      required: ['docId'],
      properties: {
        docId: { type: ['string'] },
        name: { type: ['string'] },
      },
    },
  },
};

const menuItemProperties: Record<string, Schema> = {
  label: { type: ['string'] },
  link: { type: ['string'] },
  visibleOnDesktop: { type: ['boolean'] },
  visibleOnMobile: { type: ['boolean'] },
  displayCount: { type: ['number', 'nil'] },
  linkMetaData: linkMetaDataSchema,
};

const menuItemSchema: Schema = {
  type: ['object'],
  properties: menuItemProperties,
  required: ['label'],
};

// Self-reference: child items are validated with the same schema
menuItemProperties.items = {
  type: ['array', 'nil'],
  items: menuItemSchema,
};

export const menuItemsPropertySchema: Schema = {
  type: ['array', 'nil'],
  warnIfNil: true,
  items: menuItemSchema,
};

export const navBarItemsPropertySchema: Schema = {
  type: ['array', 'nil'],
  warnIfNil: true,
  items: {
    type: ['object'],
    properties: {
      link: { type: ['string'] },
      icon: { type: ['string'] },
      label: { type: ['string'] },
      visibleOnDesktop: { type: ['boolean'] },
      visibleOnMobile: { type: ['boolean'] },
      displayCount: { type: ['number', 'nil'] },
      linkMetaData: linkMetaDataSchema,
    },
    required: ['icon'],
  },
};
